export default function NewsletterRibbon() {
  return (
    <section className="newsletter-ribbon">
      <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-4 p-4">
        <div>
          <div className="small fw-bold text-uppercase mb-1">
            EAC2027 Newsletter
          </div>

          <h2 className="h3 mb-1">
            Stay connected with the aerosol community
          </h2>

          <p className="mb-0">
            Get the latest EAC2027 updates before, during, and beyond the conference.
          </p>
        </div>

        <a
          href="https://756b0975.sibforms.com/serve/MUIFAExUQ8BuBk-bI00pY3aLy2xdqWMPTqdQsszRekzMjGyX0LQC9Qnf31TB64baa4HXabH_vi6MjgOfuR0V8HaAk4eorGuSFw0x5lPeqZwDNmz7tNipgsYfh5OYS9DlHjvWkPVvCoY4G_hJQrd1tZe9XmMr2DeNxadBQyFd5F4xNYFi_RUMc5eqoZtkw6vh_pO3HCbPVlLTTkOR"
          target="_blank"
          rel="noreferrer"
          className="btn newsletter-ribbon-btn flex-shrink-0"
        >
          <i className="bi bi-envelope-paper me-2" aria-hidden="true"></i>
          Subscribe to newsletter
        </a>
      </div>
    </section>
  );
}